import React, { Component } from 'react';
import logo from './../../../assets/img/logo.png';
import warehouse from './../../../assets/img/warehouse.svg';
import Dialog from '@material-ui/core/Dialog';
import HeaderApiHandler from './../HeaderApiHandler.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import Popover from '@material-ui/core/Popover';
import UserInfo from './../../../commons/UserInfo.js';

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            dialogeOpen: false,
            allFacilities: null,
            selectedFacility: null,
            popOverOpen: false,
            anchorEl: null,
            logoutPopOver: false,
            search: '',
        };
        this.handlePopOverClose = this.handlePopOverClose.bind(this);
        this.selectFacilityPopOver = this.selectFacilityPopOver.bind(this);
        this.handlelogoutClose = this.handlelogoutClose.bind(this);
        this.selectFacilityDrop = this.selectFacilityDrop.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.showSideMenu = this.showSideMenu.bind(this);
    }

    componentDidMount() {
        if (!this.state.allFacilities) {
            this.getAllFacilities();
        }
        var user = JSON.parse(localStorage.getItem('user'));
        this.setState({ user: user });
        var facility = JSON.parse(localStorage.getItem('selectedFacility'));
        if (!facility) {
            this.selectFacilityFullScreen();
        } else {
            this.setState({ selectedFacility: facility });
        }
    }

    selectFacilityDrop() {
        if (!this.state.popOverOpen) {
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener(
                'click',
                this.handleOutsideClick,
                false
            );
        }
        if (!this.state.popOverOpen) {
            this.setState({ popOverOpen: true });
        } else {
            this.setState({ popOverOpen: false });
        }
    }

    handleOutsideClick(e) {
        if (this.node.contains(e.target)) {
            return;
        }
        this.selectFacilityDrop();
    }

    getAllFacilities() {
        HeaderApiHandler.getAllFacilities()
            .then(
                function (resp) {
                    this.setState({ allFacilities: resp });
                }.bind(this)
            )
            .catch(function (error) {});
    }

    selectFacilityFullScreen() {
        this.setState({
            dialogeOpen: true,
        });
    }

    selectFacility(facility) {
        if (this.state.selectedFacility) {
            if (
                this.state.selectedFacility.facilityId !== facility.facilityId
            ) {
                this.setState({
                    selectedFacility: facility,
                    popOverOpen: false,
                });
                window.location.reload();
            } else {
                this.setState({ popOverOpen: false });
            }
        } else {
            this.setState({ selectedFacility: facility, dialogeOpen: false });
            window.location.reload();
        }
        localStorage.setItem('selectedFacility', JSON.stringify(facility));
    }

    showSideMenu() {
        this.props.showSideMenu();
    }

    handlePopOverClose() {
        this.setState({ popOverOpen: false });
    }

    handlelogoutClose() {
        this.setState({ logoutPopOver: false });
    }

    selectFacilityPopOver = (placement) => (event) => {
        const { currentTarget } = event;
        this.setState((state) => ({
            popOverOpen: state.placement !== placement || !state.popOverOpen,
            anchorEl: currentTarget,
        }));
    };

    logoutOpen = (placement) => (event) => {
        const { currentTarget } = event;
        this.setState((state) => ({
            logoutPopOver:
                state.placement !== placement || !state.logoutPopOver,
            anchorEl: currentTarget,
        }));
    };

    getFacilities() {
        var facilities;
        if (this.state.allFacilities) {
            facilities = this.state.allFacilities.map((facility, index) => {
                return (
                    <button
                        className='btn btn-default facility-btn'
                        key={index}
                        onClick={() => this.selectFacility(facility)}
                    >
                        {facility.facilityName}
                    </button>
                );
            });
        } else {
            facilities = (
                <CircularProgress
                    size={30}
                    thickness={5}
                    style={{ color: '#212121' }}
                />
            );
        }
        return facilities;
    }

    getFacilitiesDrops() {
        var facilities;
        let s = this.state.search.toLowerCase();
        if (this.state.allFacilities) {
            var fac = this.state.allFacilities;
            fac.sort(function (a, b) {
                return a.facilityName > b.facilityName
                    ? 1
                    : b.facilityName > a.facilityName
                    ? -1
                    : 0;
            });
            facilities = this.state.allFacilities
                .filter((f) => {
                    return f.facilityName.toLowerCase().includes(s);
                })
                .map((facility, index) => {
                    return (
                        <div className='option-wrapper' key={index}>
                            <div
                                className='user-option'
                                onClick={() => this.selectFacility(facility)}
                            >
                                {facility.facilityName}
                            </div>
                        </div>
                    );
                });
        } else {
            facilities = (
                <CircularProgress
                    size={30}
                    thickness={5}
                    style={{ color: '#212121' }}
                />
            );
        }
        return (
            <div>
                <input
                    className='facility-search'
                    type='text'
                    value={this.state.search}
                    onChange={(e) => {
                        this.setState({ search: e.target.value });
                    }}
                    placeholder='Search facility'
                />
                {facilities}
            </div>
        );
    }

    showFacilities() {
        return (
            <div className='facility-selector'>
                <div
                    style={{
                        borderBottom: '1px solid #7f8c8d',
                        paddingBottom: '15px',
                    }}
                >
                    <div className='row'>
                        <div className='col-md-2 col-sm-2 col-xs-3'>
                            <img
                                src={warehouse}
                                alt='warehouse'
                                style={{ width: '50px', height: '50px' }}
                            />
                        </div>
                        <div className='col-md-10 col-sm-10 col-xs-9 label-text'>
                            Select Fulfillment Center (Warehouse)
                        </div>
                    </div>
                </div>
                <div className='facilities'>{this.getFacilities()}</div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <header>
                    <div className='header-bar '>
                        <nav>
                            <div className='row no-margin'>
                                <div className='col-md-2 hidden-sm hidden-xs logo logo-box'>
                                    <a href='/'>
                                        <img
                                            src={logo}
                                            style={{ maxHeight: '63px' }}
                                            alt='bradman'
                                        />
                                    </a>
                                </div>
                                <div className='col-md-10 header-box'>
                                    <div className='row'>
                                        <div className='col-xs-3 col-sm-4 col-md-5'>
                                            <div
                                                className='visible-xs visible-sm'
                                                style={{
                                                    lineHeight: '65px',
                                                    fontSize: '25px',
                                                }}
                                                onClick={this.showSideMenu}
                                            >
                                                <i className='fas fa-bars'></i>
                                            </div>
                                        </div>
                                        <div
                                            className='col-xs-9 col-sm-4 col-md-4'
                                            ref={(node) => {
                                                this.node = node;
                                            }}
                                        >
                                            {this.state.selectedFacility ? (
                                                <div
                                                    className='header-action-label'
                                                    onClick={
                                                        this.selectFacilityDrop
                                                    }
                                                >
                                                    <span className='hidden-xs'>
                                                        FC Selected: &nbsp;{' '}
                                                    </span>
                                                    {
                                                        this.state
                                                            .selectedFacility
                                                            .facilityName
                                                    }{' '}
                                                    &nbsp;{' '}
                                                    <i className='fas fa-chevron-down'></i>
                                                </div>
                                            ) : null}
                                            {this.state.popOverOpen ? (
                                                <div
                                                    className='drop-down-selector'
                                                    style={{
                                                        zIndex: '10',
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    {this.getFacilitiesDrops()}
                                                </div>
                                            ) : null}
                                        </div>
                                        <div
                                            className='hidden-xs col-sm-4 col-md-3'
                                            style={{ textAlign: 'right' }}
                                        >
                                            {this.state.user ? (
                                                <div
                                                    className='header-action-label'
                                                    onClick={this.logoutOpen(
                                                        'top-left'
                                                    )}
                                                >
                                                    {
                                                        this.state.user
                                                            .bradmanUserProfile
                                                            .displayName
                                                    }{' '}
                                                    &nbsp;{' '}
                                                    <i className='fas fa-chevron-down'></i>
                                                </div>
                                            ) : null}
                                            <Popover
                                                open={this.state.logoutPopOver}
                                                anchorEl={this.state.anchorEl}
                                                onClose={this.handlelogoutClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                classes={{
                                                    paper: 'noOverflowHidden',
                                                }}
                                            >
                                                <div>
                                                    <UserInfo />
                                                </div>
                                            </Popover>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </header>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.state.dialogeOpen}
                >
                    <div>{this.showFacilities()}</div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/Header/Components/Header.js